/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { LicensedProducts } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns the licensed products for the current tenant.
 *
 * @agent-skills: tenant-context
 */
export const useLicensedProducts = (): LicensedProducts => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.licensedProducts) || {};
};
